<template>
<div>
  Stress Testing with multiple games running in parallel...
</div>
</template>

<script>
export default {
  name: 'stress-test3',
  created() {
    // this.oneMatch();
    // this.bigStressWithTimer();
    this.bigStressWithoutTimer();
  },
  methods: {
    oneMatch() {
      /* eslint-disable */
      window.open("http://localhost:8181/?#/testGameFlow/300000001001", '_blank');
      window.open("http://localhost:8181/?#/testGameFlow/300000001002", '_blank');
    },
    bigStressWithTimer() {
      let i = 201;
      let msisdn = '9001000';
      //let msisdn = '30000001000';
      const timer = setInterval(() => {
        //window.open(`http://10.20.68.80:8181/?#/testGameFlow/${msisdn.concat(i.toString())}`, '_blank');
        window.open(`http://sub_duel_stresstest:44891/?#/testGameFlow/${msisdn.concat(i.toString())}`, '_blank');
        i+=1;
        if(i === 250) {
          clearInterval(timer);
        }
      }, Math.random()*500);
    },
    bigStressWithoutTimer() {
      let i;
      let msisdn = '9001000';
      for(i=201; i<251; i++) {
        window.open(`http://sub_duel_stresstest:44891/?#/testGameFlow/${msisdn.concat(i.toString())}`, '_blank');
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/stressTests/StressTest3.vue